<template>
    <div ref="root" class="controlhead">
        <a
            v-if="showClose"
            href="#"
            v-on:click.prevent="$emit('close')"
            class="controlhead__close"
            v-tooltip="$helpers.uiText('U034')"
            >Schließen</a
        >

        <h3
            v-if="title || help"
            class="controlhead__title"
            :class="{
                'controlhead__title--with-remove': showRemove
            }"
        >
            {{ title }}
            <img
                v-if="help"
                v-tooltip="help"
                v-bind:src="generateMediaUrl({ path: 'static/ui/misc/help.svg' })"
                class="help-icon"
                width="20"
                alt=""
            />
        </h3>

        <a
            v-if="showRemove"
            href="#"
            v-on:click.prevent="$emit('remove')"
            class="controlhead__remove"
            v-tooltip="removeText"
            >Löschen</a
        >

        <div v-if="showCloseMessage" class="controlhead-message controlhead-message--close">
            <div class="controlhead-message__cutout controlhead-message__cutout--left"></div>
            <div class="controlhead-message__cutout controlhead-message__cutout--right"></div>

            <template v-if="showSave">
                <p class="controlhead-message__note">
                    Möchten Sie die Änderungen vor dem Schließen speichern?
                </p>
                <a href="#" v-on:click.prevent="closeDeny" class="controlhead-message__close"
                    >Schließen</a
                >
                <a href="#" v-on:click.prevent="closeSave" class="button button--icon-checkmark"
                    >Ja</a
                >
                <a href="#" v-on:click.prevent="closeDiscard" class="button button--icon-x">Nein</a>
            </template>
            <template v-else>
                <p class="controlhead-message__note">
                    Bitte füllen Sie alle rot markierten Felder korrekt aus!
                </p>
                <a href="#" v-on:click.prevent="closeDeny" class="controlhead-message__close"
                    >Schließen</a
                >
                <a href="#" v-on:click.prevent="closeDeny" class="button button--icon-checkmark"
                    >OK</a
                >
                <a href="#" v-on:click.prevent="closeDiscard" class="button button--icon-x"
                    >Verwerfen</a
                ></template
            >
        </div>

        <div v-if="showRemoveMessage" class="controlhead-message controlhead-message--remove">
            <div class="controlhead-message__cutout controlhead-message__cutout--left"></div>
            <div class="controlhead-message__cutout controlhead-message__cutout--right"></div>
            <p class="controlhead-message__note" v-html="$helpers.uiText('R080')"></p>
            <a href="#" v-on:click.prevent="removeDeny" class="controlhead-message__close"
                >Schließen</a
            >
            <a href="#" v-on:click.prevent="removeAccept" class="button button--icon-trashcan"
                >Löschen</a
            >
            <a href="#" v-on:click.prevent="removeDeny" class="button button--icon-x">Nein</a>
        </div>

        <div v-if="showGlobal" class="controlhead__global">
            Änderungen auf Einstellungsseiten mit diesem Symbol werden immer seitenübergreifend
            vorgenommen.
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { OpenedRouteMixin } from '@/mixins/OpenedRouteMixin';
import { EventBus } from '@/helpers/event-bus';

export default {
    data() {
        return {
            showCloseMessage: false,
            showRemoveMessage: false
        };
    },
    components: {},
    methods: {
        ...mapActions(['rollbackDifferInRoute']),
        async closeDiscard() {
            this.showCloseMessage = false;
            await this.rollbackDifferInRoute(this.openedRoute);
            EventBus.$emit('controlhead-close-discarded');
        },
        async closeSave() {
            this.showCloseMessage = false;
            await this.$parent.save();
            EventBus.$emit('controlhead-close-saved');
        },
        closeDeny() {
            this.showCloseMessage = false;
            EventBus.$emit('controlhead-close-denied');
        },
        removeAccept() {
            this.showRemoveMessage = false;
            EventBus.$emit('controlhead-remove-accepted');
        },
        removeDeny() {
            this.showRemoveMessage = false;
            EventBus.$emit('controlhead-remove-denied');
        }
    },
    computed: {
        ...mapGetters(['generateMediaUrl'])
    },
    created() {},
    mounted() {
        EventBus.$on('controlhead-close-open', (route) => {
            if (route === this.openedRoute) {
                EventBus.$off('controlhead-close-discard');
                EventBus.$off('controlhead-close-saved');
                EventBus.$off('controlhead-close-denied');
                this.showCloseMessage = true;
            }
        });
        EventBus.$on('controlhead-remove-open', (route) => {
            if (route === this.openedRoute) {
                EventBus.$off('controlhead-remove-accepted');
                EventBus.$off('controlhead-remove-denied');
                this.showRemoveMessage = true;
            }
        });
    },
    mixins: [OpenedRouteMixin],
    props: {
        title: String,
        help: String,
        showClose: Boolean,
        showRemove: Boolean,
        showSave: Boolean,
        showGlobal: Boolean,
        removeText: String
    }
};
</script>
